module.exports = __webpack_public_path__ + "dd95cafa739e9da376f7c31a1af48cfd.svg";